<template>
	<div class="batch-tabs-config">
		<div class="batch-header">
			<div class="batch-toolbar">
				<div class="shop-select">
					<span class="shop-select__label">初始数据店铺</span>
					<el-select
						v-model="selectedShopId"
						size="large"
						placeholder="请选择店铺"
						filterable
						:loading="shopListLoading"
						@change="onShopChange"
					>
						<el-option
							v-for="item in shopOptions"
							:key="item.id"
							:label="item.mall_name || item.shop_name || String(item.id)"
							:value="String(item.id)"
						/>
					</el-select>
				</div>
			</div>
			<div class="batch-notice">
				<i class="el-icon-warning-outline"></i>
				<p>
					如果对配置项含义不理解，部分不支持批量配置的字段，请到菜单
					<span class="notice-path">拼多多账户</span>
					点击
					<span class="notice-highlight">《店铺配置》</span>
					里进行配置及查看
				</p>
			</div>
		</div>

		<div class="navmenu">
			<div class="nav-tabs">
				<router-link
					v-for="item in menuItems"
					:key="item.id"
					:to="{ path: item.path, query: navQuery }"
					class="nav-tab"
					:class="{ 'is-active': isTabActive(item) }"
				>
					{{ item.name }}
				</router-link>
			</div>
		</div>

		<div class="box">
			<div ref="contentScroll" class="container">
				<router-view :key="$route.fullPath"/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'BatchTabsConfig',
	provide() {
		return {
			retailShop: this,
		}
	},
	data() {
		return {
			menuItems: [
				{ id: 1, name: '拼多多配置', path: '/StoreConfig/batchDetailed/mSetup' },
				{ id: 2, name: '必选渠道配置(订单匹配)', path: '/StoreConfig/batchDetailed/channelOrders' },
				{ id: 3, name: '必选渠道配置(库存匹配)', path: '/StoreConfig/batchDetailed/channelStock' },
				{ id: 4, name: '备选渠道配置(库存匹配)', path: '/StoreConfig/batchDetailed/backupChannelStock' },
				{ id: 5, name: '宝贝库存数量显示规则设置', path: '/StoreConfig/batchDetailed/stockDisplayRule' },
				{ id: 6, name: '手工指定-通用规则', path: '/StoreConfig/batchDetailed/manualAssignRule' },
				{ id: 7, name: '根据一口价自动匹配渠道规则配置', path: '/StoreConfig/batchDetailed/fixedPriceChannelRule' },
				{ id: 8, name: '安全库存自动匹配渠道规则设置', path: '/StoreConfig/batchDetailed/safetyStockPriceRule' },
				{ id: 9, name: '订单自动匹配渠道规则', path: '/StoreConfig/batchDetailed/orderAutoMatchRule' },
				{ id: 10, name: '商品一键上架规则', path: '/StoreConfig/batchDetailed/oneClickListingRule' },
				{ id: 11, name: '黑名单渠道', path: '/StoreConfig/batchDetailed/blacklistChannel' },
			],
			selectedShopId: '',
			shopOptions: [],
			shopListLoading: false,
			shopId: '',
			shopDetail: null,
			shopDetailLoading: false,
		}
	},
	computed: {
		currentShopId() {
			return this.selectedShopId || this.$route.query.id || sessionStorage.getItem('batchRetailShopId') || ''
		},
		shopName() {
			return (this.shopDetail && this.shopDetail.mall_name) || ''
		},
		navQuery() {
			const id = this.currentShopId
			return id ? { id } : {}
		},
		activeTabPath() {
			const path = this.$route.path
			if (path === '/StoreConfig/batchConfig') {
				return '/StoreConfig/batchDetailed/mSetup'
			}
			return path
		},
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(path) {
				this.scrollContentToTop()
				if (path === '/StoreConfig/batchConfig') {
					this.ensureDefaultTab()
				}
			},
		},
		currentShopId: {
			immediate: true,
			handler(id) {
				if (id) {
					this.fetchShopDetail(id)
				}
			},
		},
	},
	mounted() {
		this.fetchShopList()
		this.ensureDefaultTab()
	},
	methods: {
		scrollContentToTop() {
			this.$nextTick(() => {
				const el = this.$refs.contentScroll
				if (el) {
					el.scrollTop = 0
				}
			})
		},
		isTabActive(item) {
			return this.activeTabPath === item.path
		},
		ensureDefaultTab() {
			if (this.$route.path !== '/StoreConfig/batchConfig') {
				return
			}
			this.$router.replace({
				path: '/StoreConfig/batchDetailed/mSetup',
				query: this.navQuery,
			}).catch(function() {})
		},
		fetchShopList() {
			this.shopListLoading = true
			this.$axios.post('api/retail_shop/list', {
				page: 1,
				limit: 500,
			}).then(res => {
				if (res.data.code == 0) {
					const list = (res.data.data && res.data.data.list) || []
					this.shopOptions = list
					this.initSelectedShop(list)
				} else {
					this.$message.error(res.data.message || '获取店铺列表失败')
				}
			}).catch(err => {
				console.log(err)
				this.$message.error('获取店铺列表失败')
			}).finally(() => {
				this.shopListLoading = false
			})
		},
		initSelectedShop(list) {
			if (!list.length) {
				return
			}
			const queryId = this.$route.query.id || sessionStorage.getItem('batchRetailShopId') || ''
			const matched = list.find(function(item) {
				return String(item.id) === String(queryId)
			})
			this.selectedShopId = matched ? String(matched.id) : String(list[0].id)
			if (this.selectedShopId) {
				sessionStorage.setItem('batchRetailShopId', this.selectedShopId)
			}
		},
		onShopChange(id) {
			if (!id) {
				return
			}
			sessionStorage.setItem('batchRetailShopId', String(id))
			this.$router.replace({
				path: this.$route.path,
				query: Object.assign({}, this.$route.query, { id: id }),
			}).catch(function() {})
		},
		fetchShopDetail(id, force) {
			const shopId = String(id)
			if (!shopId) {
				return
			}
			if (!force && this.shopId === shopId && (this.shopDetail || this.shopDetailLoading)) {
				return
			}
			this.shopId = shopId
			this.shopDetailLoading = true
			this.$axios.post('api/retail_shop/detail', { id: shopId }).then(res => {
				if (res.data.code == 0) {
					this.shopDetail = res.data.data || null
				} else {
					this.$message.error(res.data.message || '获取店铺详情失败')
				}
			}).catch(err => {
				console.log(err)
				this.$message.error('获取店铺详情失败')
			}).finally(() => {
				this.shopDetailLoading = false
			})
		},
	},
}
</script>

<style scoped lang="less">
.batch-tabs-config {
	width: 100%;
	min-width: 1200px;
	height: calc(100vh - 61px);
	display: flex;
	flex-direction: column;
	background: #fff;
}

.batch-header {
	flex-shrink: 0;
	padding: 14px 16px 12px;
	background: linear-gradient(180deg, #fafbfc 0%, #fff 100%);
	border-bottom: 1px solid #eef0f3;
}

.batch-toolbar {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 12px;
	margin-bottom: 12px;
	padding: 12px 14px;
	background: #fff;
	border: 1px solid #eef0f3;
	border-radius: 8px;
	box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.shop-select {
	display: flex;
	align-items: center;
	gap: 12px;

	&__label {
		position: relative;
		padding-left: 10px;
		font-size: 14px;
		font-weight: 500;
		color: #303133;
		white-space: nowrap;

		&::before {
			content: '';
			position: absolute;
			left: 0;
			top: 50%;
			width: 3px;
			height: 14px;
			margin-top: -7px;
			background: #ff4714;
			border-radius: 2px;
		}
	}

	/deep/ .el-select {
		width: 280px;
	}

	/deep/ .el-input__inner {
		border-color: #e4e7ed;
		border-radius: 6px;

		&:hover,
		&:focus {
			border-color: #ff4714;
		}
	}
}

.batch-notice {
	display: flex;
	align-items: flex-start;
	gap: 10px;
	padding: 10px 14px;
	background: rgba(230, 162, 60, 0.08);
	border: 1px solid rgba(230, 162, 60, 0.22);
	border-radius: 8px;

	i {
		flex-shrink: 0;
		margin-top: 2px;
		font-size: 16px;
		color: #e6a23c;
	}

	p {
		margin: 0;
		font-size: 13px;
		line-height: 1.7;
		color: #8a6d3b;
	}

	.notice-path,
	.notice-highlight {
		color: #ff4714;
		font-weight: 500;
	}

	.notice-path {
		margin: 0 4px;
	}
}

.navmenu {
	flex-shrink: 0;
	background-color: #fff;
	border-bottom: 1px solid #eef0f3;
	padding: 8px 16px 10px;

	.nav-tabs {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
	}

	.nav-tab {
		display: inline-flex;
		align-items: center;
		padding: 7px 14px;
		font-size: 13px;
		line-height: 1.4;
		color: #606266;
		text-decoration: none;
		border: 1px solid transparent;
		border-radius: 6px;
		white-space: nowrap;
		transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

		&:hover {
			color: #303133;
			background-color: #f5f7fa;
		}

		&.is-active {
			color: #ff4714;
			background-color: rgba(255, 71, 20, 0.1);
			border-color: rgba(255, 71, 20, 0.22);
			font-weight: 500;
			box-shadow: 0 1px 2px rgba(255, 71, 20, 0.08);
		}
	}
}

.box {
	flex: 1;
	min-height: 0;
	padding-top: 8px;
	box-sizing: border-box;
	overflow: hidden;

	.container {
		width: 100%;
		height: 100%;
		background-color: #fff;
		box-sizing: border-box;
		padding: 10px 10px 0;
		overflow: auto;

		/deep/ .el-table {
			font-size: 13px;

			th.el-table__cell {
				font-size: 12px;
			}

			.el-table__empty-text {
				font-size: 12px;
			}

			.cell {
				line-height: 1.45;
			}
		}

		/deep/ .el-form-item__label {
			font-size: 13px;
			line-height: 40px;
		}

		/deep/ .el-input__inner,
		/deep/ .el-input-number .el-input__inner {
			height: 40px;
			line-height: 40px;
		}

		/deep/ .el-input--medium .el-input__inner,
		/deep/ .el-input--small .el-input__inner,
		/deep/ .el-input--mini .el-input__inner {
			height: 40px;
			line-height: 40px;
		}

		/deep/ .el-input-number--medium,
		/deep/ .el-input-number--small,
		/deep/ .el-input-number--mini {
			line-height: 38px;

			.el-input__inner {
				height: 40px;
				line-height: 40px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/batchTabsConfig.vue